'use strict';
import angular from 'angular';
import $ from 'jquery';

import modalUpdateDueDateHtmlUrl from '../../tasks/views/modal_updateDueDate.html';
import taskAssignmentHistoryHtmlUrl from '../../tasks/views/modal_taskAssignmentHistory.html';

angular.module('queues.ctrls', [])
    .controller('MyQueuesController', MyQueuesController)
    .controller('QueueManagerController', QueueManagerController)
    .controller('AddAdminQueuesController', AddAdminQueuesController)
    .controller('AdminQueuesController', AdminQueuesController);

MyQueuesController.$inject = ['$rootScope', '$compile', '$scope', '$timeout', '$modal', 'TaskService', '$state', 'UserService', 'QueuesService', '$ioAlert', 'ClusterService', 'DateRangeService', '$stateParams', 'ModalService', 'CommentService', '$filter', 'InstanceSettings', 'FormService', 'CurrentUser']

function MyQueuesController($rs, $compile, $scope, $timeout, $modal, TaskService, $state, UserService, QueuesService, $ioAlert, ClusterService, DateRangeService, $stateParams, ModalService, CommentService, $filter, InstanceSettings, FormService, CurrentUser) {

    var STATUS_TASK_ASSIGNMENT_COMPLETE = 19;
    var STATUS_TASK_ASSIGNMENT_CLOSED = 20;
    var MAX_RPIORITY = 10;
    var MIN_PRIORITY = 1;

    let currentUser;

    $scope.tasks = [];
    $scope.queues = [];
    $scope.toggleQueue = [];
    $scope.loadedCount = 0;
    $scope.restrictOrders = false;
    $scope.restrictAdminActions = false;
    $scope.isTableInitialized = false;
    $scope.associatedTasks = {};
    $scope.isNoQueues = false;
    $scope.isVendor = false;
    $scope.searchQueues = {};
    $scope.dtQueueOptions = [];
    $scope.dtOptions = {};
    $scope.alreadyRendered = [];
    $scope.enableTaskIcons = false;
    $scope.selectedTaskIds = [];
    $scope.selectedQueueId = null;
    $scope.userAssignArr = [];
    $scope.selectedRow = [];
    $scope.isFilteringTasks = false;
    $scope.hideExclamation = false;
    $scope.taskAssignmentHistory = [];
    $scope.hasFlights = [];

    $scope.delegate = {
        onApplyFilter(filter) {
            $scope.filter = filter
            $scope.showFilteredTasks()
        },
        onResetFilter() {
            $scope.filter = undefined
            $scope.showAllTasks()
        }
    }

    var currentDate = new Date().setHours(0, 0, 0, 0);

    InstanceSettings.getTasksAssignmentsDefaultFilterValue(function (filter) {
        $scope.isFilteringTasks = true
        $scope.filter = filter
    })

    $scope.showAllTasks = function () {
        resetScopeSelection()
        $scope.isFilteringTasks = false
        let $tds = $('td.details-control.icomoon-caret-down');
        $tds.click()
        $tds.click()
    }

    $scope.showFilteredTasks = function () {
        resetScopeSelection()
        $scope.isFilteringTasks = true
        let $tds = $('td.details-control.icomoon-caret-down');
        $tds.click()
        $tds.click()
    }


    var initDataTableOptions = function() {

        $scope.dtOptions.data = $scope.queues;
        $scope.dtOptions.columns = [{
            field: 'expand',
            label: '',
            orderable: false,
            format: 'custom',
            className: 'details-control'
        }, {
            field: 'name',
            label: 'Queue'
        }, {
            field: 'count',
            label: 'Active Task Assignments'
        }];
        $scope.dtOptions.entityName = 'queues';
        $scope.dtOptions.scroller = true;
        $scope.dtOptions.itemName = 'queue';
        $scope.dtOptions.customRenders = {};
        $scope.dtOptions.hasFixedHeader = false;
        $scope.dtOptions.customRenders['expand'] = function(data, type, full) {
            return '';
        };
        $scope.dtOptions.fnCreatedRow = function(row, raw, id) {

            //table render guard
            $scope.alreadyRendered[raw.id] = 0;

            var table = $('div.order-table').find('[legacy-datatable]').DataTable();
            var tr = table.row(row);

            $(row).find('td.details-control').addClass('icomoon-caret-right');
            $(row).find('td.details-control').on('click', function(event) {
                if (tr.child.isShown()) {
                    tr.child.hide();
                    $scope.alreadyRendered[raw.id] = 0;
                    $(this).removeClass('icomoon-caret-down');
                    $(this).addClass('icomoon-caret-right');
                } else {
                    tr.child(
                        '<div class="panel panel-default">' +
                        '<table class="table innerTable">' +
                        '<tr>' +
                        '<td class="no-border">' +
                        '<div class="main-content">' +
                        '<div class="detail-order-table queue-item-table-' + id + '">' +
                        '</div>' +
                        '</div>' +
                        '</td>' +
                        '</tr>' +
                        '</table>' +
                        '</div>'
                    ).show();
                    if (tr.child.isShown()) {
                        var genQueueItems = function() {
                            var lineItemElem = 'div.queue-item-table-' + id;
                            var tableContainer = $(tr.child()).find(lineItemElem);
                            //keeping for reassessment of approach after release
                            //var template = '<div ng-if="toggleQueue['+raw.id+']" style="width:100%;"><table legacy-datatable dt-options="dtQueueOptions['+raw.id+']" class="display responsive no-wrap"></table></div>';
                            var safeId = parseInt(raw.id, 10);
                            if (isNaN(safeId)) { return; }
                            var template = '<div ng-if="toggleQueue[' + safeId + ']"><table legacy-datatable dt-options="dtQueueOptions[' + safeId + ']"></table></div>';
                            var linkFn = $compile(template);
                            var content = linkFn($scope);
                            tableContainer.append(content);
                        };
                        genQueueTable(raw, genQueueItems);
                    }
                    $(this).removeClass('icomoon-caret-right');
                    $(this).addClass('icomoon-caret-down');
                }
            });
        };
        $scope.dtOptions.fnInitComplete = function(table) {
            let $tableWrapper = $(table.nTableWrapper);
            //Show initially invisible search input and length menu
            $tableWrapper.find('div.dataTables_filter, div.dataTables_length').showV();
            //Add placeholder to search input
            $tableWrapper.find('div.dataTables_filter input').attr('placeholder', 'Search queues...');

            if ($state.params && $state.params.filter) {
                table.aoData.forEach(function(row) {
                    let rowData = row._aData;
                    if (row._aData.name === $state.params.filter) {
                        let dataTable = $('div.order-table').find('[legacy-datatable]').DataTable();
                        let tr = dataTable.row(row.idx);
                        dataTable.scroller.measure();
                        dataTable.row(row.idx).scrollTo();
                        tr.child(
                            '<div class="panel panel-default">' +
                            '<table class="table innerTable">' +
                            '<tr>' +
                            '<td class="no-border">' +
                            '<div class="main-content">' +
                            '<div class="detail-order-table queue-item-table-' + row.idx + '">' +
                            '</div>' +
                            '</div>' +
                            '</td>' +
                            '</tr>' +
                            '</table>' +
                            '</div>'
                        ).show();
                        if (tr.child.isShown()) {
                            let genQueueItems = function() {
                                let lineItemElem = 'div.queue-item-table-' + row.idx;
                                let tableContainer = $(tr.child()).find(lineItemElem);
                                let safeId = parseInt(rowData.id, 10);
                                if (isNaN(safeId)) { return; }
                                let template = '<div ng-if="toggleQueue[' + safeId + ']"><table legacy-datatable dt-options="dtQueueOptions[' + safeId + ']"></table></div>';
                                let linkFn = $compile(template);
                                let content = linkFn($scope);
                                tableContainer.append(content);
                            };
                            genQueueTable(rowData, genQueueItems);
                        }
                        $(this).removeClass('icomoon-caret-right');
                        $(this).addClass('icomoon-caret-down');
                    }
                });
            }
        };
    };

    var initQueueDataTableOptions = function(queueId) {
        $scope.selectedQueueId = queueId;
        $scope.dtQueueOptions[queueId] = {};
        $scope.dtQueueOptions[queueId].hasFixedHeader = false;
        $scope.dtQueueOptions[queueId].cloneable = $scope.hasCategoryManagement;
        $scope.dtQueueOptions[queueId].editable = $scope.hasCategoryManagement;
        $scope.dtQueueOptions[queueId].data = $scope.associatedTasks[queueId];
        $scope.dtQueueOptions[queueId].columns = [
            //keeping for reassessment of approach after release
            //{field: 'control', label: '', className: 'control', orderable: false},
            {
                field: 'id',
                format: 'custom',
                label: 'Task #',
                className: 'link-cell'
            }, {
                field: 'priority',
                label: 'Priority',
                typeOverride: 'natural'
            }, {
                field: 'order_id',
                format: 'custom',
                label: 'Order Number',
                className: 'action-order'
            }, {
                field: 'line_item_id',
                format: 'custom',
                label: $scope.hasFlights[queueId] ? 'Line Item - Flight' : 'Line Item',
                className: 'action-order',
                typeOverride: 'natural'
            }, {
                field: 'sales_region',
                label: 'Sales Region'
            }, {
                field: 'description',
                label: 'Task Description'
            }, {
                field: 'task_created_date',
                label: 'Task Created Date'
            }, {
                field: 'due_date',
                label: 'Due Date',
                className: 'none'
            }, {
                field: 'line_item_campaign_name_flight_name',
                label: $scope.hasFlights[queueId] ? 'Name' : 'Campaign Name',
                className: 'none'
            }, {
                field: 'line_item_flight_start',
                label: $scope.hasFlights[queueId] ? 'Start' : 'Line Item Start',
                className: 'none'
            }, {
                field: 'line_item_flight_end',
                label: $scope.hasFlights[queueId] ? 'End' : 'Line Item End',
                className: 'none'
            }, {
                field: 'status_name',
                label: 'Status'
            }, {
                field: 'client_name',
                label: 'Client',
                className: 'none'
            }, {
                field: 'salesperson',
                label: 'Salesperson',
                className: 'none'
            }, {
                field: 'campaign_manager_name',
                label: 'Campaign Manager',
                className: 'none'
            }, {
                field: 'assigned_user_name',
                label: 'Assigned User',
                className: 'none'
            }, {
                field: 'actions',
                label: 'Actions',
                is_primary_key: true,
                format: 'custom'
            }
        ];
        $scope.dtQueueOptions[queueId].entityName = 'queues';
        //keeping for reassessment of approach after release
        //$scope.dtQueueOptions[queueId].inner = true;
        $scope.dtQueueOptions[queueId].itemName = 'queue';
        $scope.dtQueueOptions[queueId].iActions = 5;
        $scope.dtQueueOptions[queueId].customRenders = {};
        $scope.dtQueueOptions[queueId].customRenders['id'] = function(data, type, full) {
            return '<a href="#/items/myTasks/' + data + '?myQueues=' + queueId + '&fromPage=myQueues" class="link-cell order-link" data-id="' + data + '">' + data + '</a>';
        };
        $scope.dtQueueOptions[queueId].customRenders['logged_time'] = function(value, type, full) {
            const hours = Math.floor(value / 60);
            const minutes = value % 60;
            if (minutes < 10) {
                return hours + ":0" + minutes;
            } else {
                return hours + ":" + minutes;
            }
        };
        $scope.dtQueueOptions[queueId].customRenders['order_id'] = function(data, type, full) {
            if (full.order_id) {
                if (currentUser.isAuthorizedToViewOrder()) {
                    return '<a href="#/items/myTasks/' + full.id + '/order/' + full.order_id + '" class="action-order" data-id="' + data + '">' + data + '</a>';
                }

                return full.order_id;
            }

            return '';
        };
        $scope.dtQueueOptions[queueId].customRenders['line_item_id'] = function(data, type, full) {
            if (full.line_item_id) {
                if (type === 'display' && currentUser.isAuthorizedToViewLineItem()) {
                    return '<a href="#/items/myTasks/' + full.id + '/lineItem/' + full.line_item_id +
                        '" class="action-order" data-id="' + data + '">' + data + '</a>' +
                        (full.flight_id ? '<span> - </span>' : '') +
                        (full.flight_id ? ('<a href="#/items/myTasks/' + full.id + '/lineItem/' + full.line_item_id +
                            '/flight/' + full.flight_id + '" class="action-order">' + full.flight_id + '</a>') : '');
                }

                return full.line_item_id + (full.flight_id ? (' - ' + full.flight_id) : '');
            }

            return '';
        };
        $scope.dtQueueOptions[queueId].customRenders['due_date'] = function(data, type, full) {
            return strToDateFormat(data);
        };
        $scope.dtQueueOptions[queueId].customRenders['task_created_date'] = function(data, type, full) {
            return strToDateFormat(data);
        };
        $scope.dtQueueOptions[queueId].customRenders['line_item_campaign_name_flight_name'] = function(data, type, full) {
            return full.flight_id ? (full.flight_name ? full.flight_name : full.flight_flight_name) : full.line_item_campaign_name;
        };
        $scope.dtQueueOptions[queueId].customRenders['line_item_flight_start'] = function(data, type, full) {
            return strToDateFormat(full.flight_id ? full.flight_start : full.line_item_start);
        };
        $scope.dtQueueOptions[queueId].customRenders['line_item_flight_end'] = function(data, type, full) {
            return strToDateFormat(full.flight_id ? full.flight_end : full.line_item_end);
        };
        if ($scope.hideExclamation) {
            $scope.dtQueueOptions[queueId].customRenders['priority'] = function(data, type, full) {
                return '<span>' + data + '</span>';
            };
        } else {
            $scope.dtQueueOptions[queueId].customRenders['priority'] = function(data, type, full) {
                let rData = '<span>' + data + '</span>';
                if (full.due_date_flag && full.due_date_flag == '1') { 
                    rData = rData + ' &nbsp; <span class="icon icon-exclamation-circle connectionstatus-error no-margin"></span>';
                } else if (full.escalate_date_flag && full.escalate_date_flag == '1') {
                    rData = rData + ' &nbsp; <span class="icon icon-exclamation-triangle connectionstatus-warning no-margin" style="font-size:15px;"></span>';
                }
                return rData;
            };
        }

        $scope.dtQueueOptions[queueId].customRenders['actions'] = function(data, type, full) {
            return (full.assigned_user_name ? '<a class="action action-ban has-tooltip"> <span class="icon icon-ban"></span></a>' : '<a class="action action-starttask has-tooltip" title="Start task" ng-click="startTask(task)"> <span class="icon icon-check"></span></a>') +
                ($scope.restrictAdminActions ? '' : '<a class="action action-escalate has-tooltip" title="Escalate Priority"> <span class="icon icon-arrow-up"></span></a><a class="action action-demote has-tooltip" title="Lower Priority"> <span class="icon icon-arrow-down"></span></a><a class="action action-reassign has-tooltip" title="Re-assign"> <span class="icon icon-refresh"></span></a><a class="action action-history has-tooltip" title="Task Assignment History"><span class="icon icon-history"></span></a>');
        };
        $scope.dtQueueOptions[queueId].fnCreatedRow = function(row, raw, id) {
            if (raw && raw.due_date_flag && raw.due_date_flag == '1') {
                $(row).addClass('overdue-row');
            } else if (raw && raw.escalate_date_flag && raw.escalate_date_flag == '1') {
                $(row).addClass('escalate-row');
            }
            $(row).click(function(event) {
                $scope.selectTask($scope.associatedTasks[queueId][id], queueId, id, event);
                $(this).toggleClass('selected');
            });
            $(row).find('a').each(function() {
                var $cell = $(this).closest('td');

                if ($cell.hasClass('link-cell')) {
                    $cell.click(function() {
                        $scope.openTask($scope.associatedTasks[queueId][id]);
                    });
                } else if ($cell.hasClass('action-order') && !$scope.isVendor) {
                    $cell.click(function() {
                        $scope.openOrder($scope.associatedTasks[queueId][id]);
                    });
                } else if ($(this).hasClass('action-starttask')) {
                    $(this).click(function() {
                        $scope.startTask($scope.associatedTasks[queueId][id]);
                    });
                } else if ($(this).hasClass('action-escalate')) {
                    $(this).click(function(event) {
                        $scope.escalate($scope.associatedTasks[queueId][id], queueId, id);
                    });
                } else if ($(this).hasClass('action-demote')) {
                    $(this).click(function(event) {
                        $scope.demote($scope.associatedTasks[queueId][id], queueId, id);
                    });
                } else if ($(this).hasClass('action-reassign')) {
                    $(this).click(function(event) {
                        $scope.reAssign($scope.associatedTasks[queueId][id], event);
                    });
                } else if ($(this).hasClass('action-history')) {
                    $(this).click(function(event) {
                        $scope.history($scope.associatedTasks[queueId][id]);
                    });
                }
            });
            $.core.main.tooltip($(row));
        };
    };
    $scope.openedQueue = null;
    $scope.myQueueId = $stateParams.queueId;
    var strToDateFormat = function(data) {
        if (data) {
            var dateVal = data.split('-');
            return '<span class="hide">'+dateVal[0]+dateVal[1]+dateVal[2]+'</span> ' + dateVal[1] + '/' + dateVal[2] + '/' + dateVal[0];
        } else {
            return '';
        }
    };

    var clusterSelector = $rs.$on('selectedClustersChanged', function(event, args) {
        $scope.queuesActive = false;
        getQueues();
    });

    $scope.$on('$destroy', function() {
        clusterSelector();
    });

    function resetScopeSelection() {
        $scope.selectedTaskIds = []
        $scope.enableTaskIcons = false
    }

    var getQueues = function() {
        $scope.loading = true;
        $rs.loadingInProgress = true;
        $rs.loadertitle = "Fetching My Queues";
        $scope.noClusterSelected = false
        $scope.tasks = [];
        $scope.queues = [];
        resetScopeSelection()
        $scope.loadedCount = 0;

        if (ClusterService.clusterIds.length === 0) {
            $scope.loading = false
            $rs.loadingInProgress = false
            $scope.noClusterSelected = true
            return
        }

        QueuesService.getQueuesForCurrentUser(ClusterService.clusterIds).then(function(success) {
            $scope.queuesActive = true;
            $scope.queues = QueuesService.queues;
            initDataTableOptions();
            $rs.loadingInProgress = false;
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again.', 'error');
            $rs.loadingInProgress = false;
        });


    };

    $scope.startTask = function(taskAssignment) {
        if (taskAssignment.user_id) {
            $ioAlert.show('Error!', 'This task has already been started.', 'error');
        } else {
            TaskService.assignToCurrentUser(taskAssignment.id).then(function(success) {
                $scope.openTask(taskAssignment);
            }, function(error) {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again.', 'error');
            });
        }
    };

    // Assign a task assignment to a specified user
    var assignToUser = function(task, user, ev) {
        if (task && user) {
            TaskService.assignTaskAssignment(task.id, user.id).then(function(success) {
                task.status_name = 'Assigned';
                task.assigned_user_name = user.first_name + ' ' + user.last_name;

                if (ev.target.className.indexOf('icon') >= 0) {
                    $(ev.target.parentElement.parentElement.previousSibling)[0].innerText = user.first_name + ' ' + user.last_name;
                } else {
                    $(ev.target.parentElement.previousSibling)[0].innerText = user.first_name + ' ' + user.last_name;
                }

                $ioAlert.show('', 'The task was successfully assigned to ' +
                    task.assigned_user_name, 'success');
            }, function(error) {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again.', 'error');
            });
        }
    };

    function genQueueTable(queue, genQueueItems) {
        $scope.associatedTasks[queue.id] = [];
        $scope.hasFlights[queue.id] = false;
        let clusterIds = null;

        // Vendors see tasks across clusters
        if (!$scope.isVendor && ClusterService.clusterIds && ClusterService.clusterIds.length) {
            clusterIds = ClusterService.clusterIds;
        }

        let params = { 'queueId': queue.id };
        if (clusterIds) {
            params['clusterIds'] = clusterIds;
        }

        if ($scope.isFilteringTasks) {
            params['filter'] = $scope.filter
        }

        TaskService.getActiveTaskAssignmentsForQueue(params).then(function() {
            $scope.associatedTasks[queue.id] = TaskService.taskAssignments;
            for (let i = 0; i < $scope.associatedTasks[queue.id].length; i++) {
                $scope.associatedTasks[queue.id][i]['control'] = null;
                $scope.associatedTasks[queue.id][i]['queue_id'] = queue.id;
                $scope.associatedTasks[queue.id][i]['queue_name'] = queue.name;
                if ($scope.associatedTasks[queue.id][i].status_id == STATUS_TASK_ASSIGNMENT_COMPLETE ||
                    $scope.associatedTasks[queue.id][i].status_id == STATUS_TASK_ASSIGNMENT_CLOSED) {
                    $scope.associatedTasks[queue.id][i]['closed'] = true;
                }
                if ($scope.associatedTasks[queue.id][i].due_date && $scope.associatedTasks[queue.id][i].escalate_date) {
                    if (currentDate >= new Date($scope.associatedTasks[queue.id][i].due_date).setHours(0, 0, 0, 0)) {
                        $scope.associatedTasks[queue.id][i].dueText = "overdue";
                    } else if (currentDate < new Date($scope.associatedTasks[queue.id][i].due_date).setHours(0, 0, 0, 0) && currentDate >= new Date($scope.associatedTasks[queue.id][i].escalate_date).setHours(0, 0, 0, 0)) {
                        $scope.associatedTasks[queue.id][i].dueText = "escalate";
                    }
                }
                if ($scope.associatedTasks[queue.id][i].task_created_date) {
                    let task_created_date = $scope.associatedTasks[queue.id][i].task_created_date.split(' ');
                    $scope.associatedTasks[queue.id][i].task_created_date = task_created_date[0];
                }
                if ($scope.associatedTasks[queue.id][i].flight_id) {
                    $scope.hasFlights[queue.id] = true;
                }
            }
            initQueueDataTableOptions(queue.id);
            return (queue.id);
        }, function() {
            console.log("Error getting task assignments for queue: " + queue.id);
        }).then(function(queueId) {
            if ($scope.alreadyRendered[queueId] === 0) {
                genQueueItems();
            }
            $scope.toggleQueue[queueId] = true;
        });
    }

    $scope.selectTask = function(task, queueId, rowId, ev) {
        var id = task.id;
        var index = $scope.selectedTaskIds.indexOf(id);
        var pos, rowIndex;
        for (var i = 0, len = $scope.userAssignArr.length; i < len; i++) {
            if (id == $scope.userAssignArr[i].id) {
                pos = i;
                break;
            }
        }
        for (var i = 0, len = $scope.selectedRow.length; i < len; i++) {
            if (id == $scope.selectedRow[i].taskId) {
                rowIndex = i;
                break;
            }
        }
        if (index >= 0) {
            $scope.selectedTaskIds.splice(index, 1);
            $scope.userAssignArr.splice(pos, 1);
            $scope.selectedRow.splice(rowIndex, 1);
            if ($scope.selectedTaskIds.length == 0) {
                $scope.enableTaskIcons = false;
                $scope.$apply();
            } else {
                $scope.enableTaskIcons = true;
                $scope.$apply();
            }
        } else {
            $scope.enableTaskIcons = true;
            $scope.selectedTaskIds.push(id);
            $scope.selectedRow.push({
                "taskId": id,
                "queueId": queueId,
                "rowId": rowId
            })
            // Assuming column before actions would be Assigned User, Storing the node to update the user on assignment
            // Need to find a better way to handle as data is not bind to view as in angular
            if (ev.target.parentElement.nodeName == 'TR') {
                $scope.userAssignArr.push({
                    'id': id,
                    'node': $(ev.target.parentElement.lastElementChild.previousSibling)
                });
            }

            $scope.$apply();
        }
    };

    $scope.commentOnTaskAssignments = function() {

        if ($scope.selectedTaskIds.length > 0) {
            var modalInstance = $modal.open(
                ModalService.returnModalType('comment', {
                    data: {
                        titleText: 'Add Comment',
                        buttonText: 'Save'
                    }
                })
            );
            modalInstance.result.then(function(comment) {
                CommentService.addCommentOnTasks($scope.selectedTaskIds, comment).then(function(success) {
                    $ioAlert.show('', 'Comment posted successfully', 'success');
                }, function(error) {
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again.', 'error');
                });
            }, function() {})
        } else {
            $ioAlert.show('Error!', 'At least one task must be selected to perform this action.', 'error');
        }
    };

    // Increment task priority by one
    $scope.escalate = function(task, queueId, rowId) {
        if (task.priority < MAX_RPIORITY) {
            TaskService.incrementTaskAssignmentPriority(task.id).then(function(success) {
                $timeout(function() {
                    $scope.toggleQueue[queueId] = false;
                    $scope.$apply();
                });
                $scope.dtQueueOptions[queueId].data[rowId].priority++;
                $timeout(function() {
                    $scope.toggleQueue[queueId] = true;
                    $scope.$apply();
                });
                $ioAlert.show('', 'Task priority escalated.', 'success');
            }, function(error) {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again.', 'error');
            });
        } else {
            $ioAlert.show('Error!', 'Maximum priority level reached.', 'error');
        }
    };

    // Decrement task priority by one
    $scope.demote = function(task, queueId, rowId) {
        if (task.priority > 1) {
            TaskService.decrementTaskAssignmentPriority(task.id).then(function(success) {
                $timeout(function() {
                    $scope.toggleQueue[queueId] = false;
                    $scope.$apply();
                });
                $scope.dtQueueOptions[queueId].data[rowId].priority--;
                $timeout(function() {
                    $scope.toggleQueue[queueId] = true;
                    $scope.$apply();
                });
                $ioAlert.show('', 'Task priority lowered.', 'success');
            }, function(error) {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again.', 'error');
            });
        } else {
            $ioAlert.show('Error!', 'Minimum priority level reached.', 'error');
        }
    };

    $scope.openTask = function(task) {
        $state.go('myTasksView', {
            taskId: task.id,
            myQueues: task.queue_id,
            fromPage: 'myQueues'
        });
    };

    $scope.openOrder = function(task) {
        $state.go('myQueuesOrder', {
            taskId: task.id,
            id: task.order_id,
            myQueues: task.queue_id
        });
    };

    $scope.openLineItem = function(task) {
        $state.go('myTasksLineitem', {
            taskId: task.id,
            lineItemId: task.reference_table_row_id
        });
    };

    $scope.reAssign = function(task, ev) {
        UserService.getUsersForQueue(task.queue_id, ClusterService.clusterIds).then(function(success) {
            var modalInstance = $modal.open(
                ModalService.returnModalType('reassign', {
                    data: {
                        items: UserService.users
                    }
                })
            );
            modalInstance.result.then(function(selectedItem) {
                assignToUser(task, selectedItem, ev);
            }, function() {
                // Modal Dismissed. Do nothing.
            });
        }, function(error) {
            console.log("Error getting users for queue");
        });
    };

    $scope.history = function(task) {
        TaskService.getTaskAssignmentHistory(task.id).then(function(response) {
            if(response) {
                $scope.taskAssignmentHistory = response;
                $modal.open({
                    animation: true,
                    controller: function($scope, $modalInstance, taskAssignmentHistory){
                        
                        $scope.taskHistory = taskAssignmentHistory.history;
                        $scope.task = taskAssignmentHistory.task;
                        
                        // Close the modal popup
                        $scope.cancel = function() {
                            $modalInstance.dismiss();
                        };
                    },
                    templateUrl: taskAssignmentHistoryHtmlUrl,
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        taskAssignmentHistory: function() {
                            return {
                                history: $scope.taskAssignmentHistory,
                                task: task
                            };
                        }
                    },
                    windowClass: 'magictime zoomInSmooth modal-overflow in'
                }).result.then(function(data) {})
            }
        }, function(error) {
            $ioAlert.show('Error!', 'Failed to start task assignments', 'error');
        });
    };

    var applyPermissions = function() {
        if ($rs.userRole.permissions == 'vendor' || $rs.userRole.permissions == 'vendor-restricted') {
            $scope.isVendor = true;
            $scope.restrictOrders = true;
            $scope.restrictAdminActions = true;
        } else if ($rs.userRole.permissions == 'sales') {
            $scope.restrictAdminActions = true;
        }
    };

    $scope.startTaskAssignments = function() {
        if ($scope.selectedTaskIds.length > 0) {
            TaskService.startTaskAssignments($scope.selectedTaskIds).then(function(success) {
                $ioAlert.show('', 'Tasks have been started', 'success');
            }, function(error) {
                $ioAlert.show('Error!', 'Failed to start task assignments', 'error');
            });
        } else {
            $ioAlert.show('Error!', 'At least one task must be selected to perform this action.', 'error');
        }
    };

    $scope.assignTaskAssignments = function() {
        if ($scope.selectedTaskIds.length > 0) {
            UserService.getUsersForQueue($scope.selectedQueueId, ClusterService.clusterIds).then(function(success) {
                var modalInstance = $modal.open(
                    ModalService.returnModalType('reassign', {
                        data: {
                            items: UserService.users
                        }
                    })
                );
                modalInstance.result.then(function(user) {
                    TaskService.assignTaskAssignments($scope.selectedTaskIds, user.id).then(function(success) {
                        var assigned_user_name = user.first_name + " " + user.last_name;
                        for (var i = 0, len = $scope.userAssignArr.length; i < len; i++) {
                            var node = $scope.userAssignArr[i].node;
                            node[0].innerText = assigned_user_name;
                        }
                        $ioAlert.show('', 'The selected tasks were successfully assigned to ' + assigned_user_name, 'success');
                    }, function(error) {
                        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again.', 'error');
                    });
                }, function() {});
            }, function(error) {
                console.log("Error getting users for queue");
            });
        } else {
            $ioAlert.show('Error!', 'At least one task must be selected to perform this action.', 'error');
        }
    };

    // Generic function to update the queues table.
    var updateQueueTable = function(type, data) {
        var queueId = [];
        for (var i = 0, len = $scope.selectedTaskIds.length; i < len; i++) {
            for (var j = 0, size = $scope.selectedRow.length; j < size; j++) {
                if ($scope.selectedRow[j].taskId == $scope.selectedTaskIds[i]) {
                    queueId.push($scope.selectedRow[j].queueId);
                    if (type == 'escalate' && $scope.dtQueueOptions[$scope.selectedRow[j].queueId].data[$scope.selectedRow[j].rowId].priority < MAX_RPIORITY) {
                        $scope.dtQueueOptions[$scope.selectedRow[j].queueId].data[$scope.selectedRow[j].rowId].priority++;
                    } else if (type == 'demote' && $scope.dtQueueOptions[$scope.selectedRow[j].queueId].data[$scope.selectedRow[j].rowId].priority > MIN_PRIORITY) {
                        $scope.dtQueueOptions[$scope.selectedRow[j].queueId].data[$scope.selectedRow[j].rowId].priority--;
                    } else if (type == 'dueDate' && data) {
                        //var dueDate = strToDateFormat(data);
                        $scope.dtQueueOptions[$scope.selectedRow[j].queueId].data[$scope.selectedRow[j].rowId].due_date = data;
                    }
                }
            }
        }
        $scope.selectedTaskIds = [];
        $scope.selectedRow = [];
        $scope.enableTaskIcons = false;
        $timeout(function() {
            for (var i = 0, len = queueId.length; i < len; i++) {
                $scope.toggleQueue[queueId[i]] = false;
            }
            $scope.$apply();
        });
        $timeout(function() {
            for (var i = 0, len = queueId.length; i < len; i++) {
                $scope.toggleQueue[queueId[i]] = true;
            }
            $scope.$apply();
        });
    }

    $scope.escalateTaskAssignmentsPriority = function() {
        if ($scope.selectedTaskIds.length > 0) {
            TaskService.incrementTaskAssignmentsPriority($scope.selectedTaskIds).then(function(success) {
                if (success.errors) {
                    updateQueueTable('escalate');
                    $ioAlert.show('Warning!', 'One or More Tasks have reached maximum priority value', 'error');
                } else {
                    if (success.taskAssignments) {
                        updateQueueTable('escalate');
                        $ioAlert.show('', 'Priority successfully escalated', 'success');
                    } else {
                        $ioAlert.show('Error!', 'Failed to increment priority', 'error');
                    }
                }
            }, function(error) {
                $ioAlert.show('Error!', 'Failed to increment priority', 'error');
            });
        } else {
            $ioAlert.show('Error!', 'At least one task must be selected to perform this action.', 'error');
        }
    };

    $scope.lowerTaskAssignmentsPriority = function() {
        if ($scope.selectedTaskIds.length > 0) {
            TaskService.decrementTaskAssignmentsPriority($scope.selectedTaskIds).then(function(success) {
                if (success.errors) {
                    updateQueueTable('demote');
                    $ioAlert.show('Warning!', 'One or More Tasks have reached minimum priority value', 'error');
                } else {
                    if (success.taskAssignments) {
                        updateQueueTable('demote');
                        $ioAlert.show('', 'Priority successfully decremented', 'success');
                    } else {
                        $ioAlert.show('Error!', 'Failed to decrement priority', 'error');
                    }
                }
            }, function(error) {
                $ioAlert.show('Error!', 'Failed to decrement priority', 'error');
            });
        } else {
            $ioAlert.show('Error!', 'At least one task must be selected to perform this action.', 'error');
        }
    };

    // Change assigned queue for multiple tasks
    $scope.changeQueue = function() {
        if ($scope.selectedTaskIds.length > 0) {
            QueuesService.getQueues(ClusterService.clusterIds).then(function(data) {
                var modalInstance = $modal.open(
                    ModalService.returnModalType('assignQueue', {
                        data: {
                            items: QueuesService.queues
                        }
                    })
                );
                modalInstance.result.then(function(selectedItem) {
                    TaskService.updateTaskAssignmentsQueue($scope.selectedTaskIds, selectedItem.id).then(function(data) {
                        if (data.errors) {
                            $ioAlert.show('Error!', data.errors[0], 'error');
                        } else {
                            $ioAlert.show('', 'The tasks have successfully been assigned to queue id ' + selectedItem.id, 'success');
                        }
                    }, function(error) {
                        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again.', 'error');
                    });
                }, function() {
                    // Modal Dismissed. Do nothing.
                });
            }, function(error) {
                console.log("Error getting available queues for cluster " + $scope.order.cluster_id[0]);
            });
        } else {
            $ioAlert.show('Error!', 'At least one task must be selected to perform this action.', 'error');
        }
    };

    $scope.followTaskAssignments = function() {
        if ($scope.selectedTaskIds.length > 0) {
            TaskService.followTaskAssignments($scope.selectedTaskIds).then(function(success) {
                $ioAlert.show('', 'You are now following these tasks', 'success');
            }, function(error) {
                $ioAlert.show('Error!', 'Failed to decrement priority', 'error');
            });
        } else {
            $ioAlert.show('Error!', 'At least one task must be selected to perform this action.', 'error');
        }
    };

    $scope.unfollowTaskAssignments = function() {
        if ($scope.selectedTaskIds.length > 0) {
            TaskService.unfollowTaskAssignments($scope.selectedTaskIds).then(function(success) {
                $ioAlert.show('', 'You are no longer following these tasks', 'success');
            }, function(error) {
                $ioAlert.show('Error!', 'Failed to decrement priority', 'error');
            });
        } else {
            $ioAlert.show('Error!', 'At least one task must be selected to perform this action.', 'error');
        }
    };

    /*
     * Update the due date for a task
     */
    $scope.updateDueDate = function() {
        if ($scope.selectedTaskIds.length > 0) {
            $modal.open({
                animation: true,
                controller: 'UpdateDueDateModalController',
                templateUrl: modalUpdateDueDateHtmlUrl,
                resolve: {
                    dueDate: function() {
                        return '';
                    }
                }
            }).result.then(function(data) {
                data = $filter('date')(data, 'yyyy-MM-dd');
                var obj = {
                    "taskAssignmentIds": $scope.selectedTaskIds,
                    "dueDate": data
                }
                TaskService.updateMultipleDueDates(obj).then(function(success) {
                    if (success.errors) {
                        $ioAlert.show('Warning!', 'Failed to update due dates', 'error');
                    } else {
                        if (success.task_assignment_ids) {
                            updateQueueTable('dueDate', data);
                            $ioAlert.show('', 'Due Dates updates successfully', 'success');
                        }
                    }
                }, function(error) {
                    $ioAlert.show('Error!', 'Failed to update due dates', 'error');
                });
            });
        } else {
            $ioAlert.show('Error!', 'At least one task must be selected to perform this action.', 'error');
        }
    }

    function getInstanceSettings_comments() {
        FormService.getInstanceSettings("role_sales_hide_sidebar").then(function (data) {
            if (data && data.id) {
                $scope.hideExclamation = (data.value === "1")?true:false;
            }
        }, function (error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            $scope.hideExclamation = false;
        });
    }

    function init() {
        ClusterService.initCluster($rs.userRole, 'multiSelectWithAllClusters');
        DateRangeService.init();
        applyPermissions();
        //show only for user_type superadmin and sales, salesmanager roles
        if ($rs.userRole.user_type === "superadmin" && $rs.userRole.permissions !== "sales" && $rs.userRole.permissions !== "sales,admin") {
            $scope.hideExclamation = false;
        } else {
            getInstanceSettings_comments();
        }
    }

    CurrentUser.get().then(function(user) {
        currentUser = user;
        if ($rs.userRole && $rs.userRole.id) {
            init();
        } else {
            UserService.getCurrentUserRole().then(function() {
                $rs.userRole = UserService.userRole;
                init();
            }, function() {});
        }
    })
}

QueueManagerController.$inject = ['$rootScope', '$scope', '$timeout', '$state', 'QueuesService', 'ClusterService', 'DateRangeService', 'TaskService', 'UserService', '$ioAlert', 'InstanceSettings'];

function QueueManagerController($rs, $scope, $timeout, $state, QueuesService, ClusterService, DateRangeService, TaskService, UserService, $ioAlert, InstanceSettings) {
    $scope.queues = [];
    $scope.isTableInitialized = false;
    $scope.sortReverse = false;
    $scope.sortType = "name";
    $scope.table = null;
    $scope.delegate = {
        onApplyFilter(filter) {
            if ($scope._isAddingSetting) {
                InstanceSettings.addSettingType(InstanceSettings.FILTER_TASK_ASSIGNMENTS, filter)
                $scope._isAddingSetting = false
            } else {
                InstanceSettings.updateSettingType(InstanceSettings.FILTER_TASK_ASSIGNMENTS, filter)
            }
        },
        onResetFilter() {
            InstanceSettings.deleteSettingType(InstanceSettings.FILTER_TASK_ASSIGNMENTS)
            $scope._isAddingSetting = true
        }
    }

    InstanceSettings
        .getSettingType(InstanceSettings.FILTER_TASK_ASSIGNMENTS)
        .then(function (data) {
            $scope._isAddingSetting = !!data.error;
        })

    var clusterSelector = $rs.$on('ClusterChanged', function(event, args) {
        if ($rs.userRole.permissions == 'superadmin') {
            getQueuedTaskSummary();
        } else {
            getQueuedTaskSummaryForCurrentUser();
        }
    });

    $scope.$on('$destroy', function() {
        clusterSelector();
    });

    var getQueuedTaskSummary = function() {
        $rs.loadingInProgress = true;
        $rs.loadertitle = "Fetching Queues List";

        QueuesService.getQueuedTaskSummary(ClusterService.clusterIds).then(function(success) {
            $scope.queuedTaskSummary = QueuesService.queuedTaskSummary;
            for (var i = 0; i < $scope.queuedTaskSummary.length; i++) {
                $scope.queuedTaskSummary[i]['total_tasks'] = parseInt($scope.queuedTaskSummary[i]['total_tasks']);
                $scope.queuedTaskSummary[i]['priority_1_count'] = parseInt($scope.queuedTaskSummary[i]['priority_1_count']);
                $scope.queuedTaskSummary[i]['priority_2_count'] = parseInt($scope.queuedTaskSummary[i]['priority_2_count']);
                $scope.queuedTaskSummary[i]['priority_3_count'] = parseInt($scope.queuedTaskSummary[i]['priority_3_count']);
                $scope.queuedTaskSummary[i]['priority_4_count'] = parseInt($scope.queuedTaskSummary[i]['priority_4_count']);
                $scope.queuedTaskSummary[i]['priority_5_count'] = parseInt($scope.queuedTaskSummary[i]['priority_5_count']);
                $scope.queuedTaskSummary[i]['priority_6_count'] = parseInt($scope.queuedTaskSummary[i]['priority_6_count']);
                $scope.queuedTaskSummary[i]['priority_7_count'] = parseInt($scope.queuedTaskSummary[i]['priority_7_count']);
                $scope.queuedTaskSummary[i]['priority_8_count'] = parseInt($scope.queuedTaskSummary[i]['priority_8_count']);
                $scope.queuedTaskSummary[i]['priority_9_count'] = parseInt($scope.queuedTaskSummary[i]['priority_9_count']);
                $scope.queuedTaskSummary[i]['priority_10_count'] = parseInt($scope.queuedTaskSummary[i]['priority_10_count']);
            }

            if (!$scope.isTableInitialized) {
                initializeTable();
            }
            $scope.loadFailed = false;
            $rs.loadingInProgress = false;
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again.', 'error');
            $rs.loadingInProgress = false;
        });
    };

    var getQueuedTaskSummaryForCurrentUser = function() {
        $rs.loadingInProgress = true;
        $rs.loadertitle = "Fetching Queues List";

        QueuesService.getQueuedTaskSummaryForCurrentUser(ClusterService.clusterIds).then(function(success) {
            $scope.queuedTaskSummary = QueuesService.queuedTaskSummary;
            for (var i = 0; i < $scope.queuedTaskSummary.length; i++) {
                $scope.queuedTaskSummary[i]['total_tasks'] = parseInt($scope.queuedTaskSummary[i]['total_tasks']);
                $scope.queuedTaskSummary[i]['priority_1_count'] = parseInt($scope.queuedTaskSummary[i]['priority_1_count']);
                $scope.queuedTaskSummary[i]['priority_2_count'] = parseInt($scope.queuedTaskSummary[i]['priority_2_count']);
                $scope.queuedTaskSummary[i]['priority_3_count'] = parseInt($scope.queuedTaskSummary[i]['priority_3_count']);
                $scope.queuedTaskSummary[i]['priority_4_count'] = parseInt($scope.queuedTaskSummary[i]['priority_4_count']);
                $scope.queuedTaskSummary[i]['priority_5_count'] = parseInt($scope.queuedTaskSummary[i]['priority_5_count']);
                $scope.queuedTaskSummary[i]['priority_6_count'] = parseInt($scope.queuedTaskSummary[i]['priority_6_count']);
                $scope.queuedTaskSummary[i]['priority_7_count'] = parseInt($scope.queuedTaskSummary[i]['priority_7_count']);
                $scope.queuedTaskSummary[i]['priority_8_count'] = parseInt($scope.queuedTaskSummary[i]['priority_8_count']);
                $scope.queuedTaskSummary[i]['priority_9_count'] = parseInt($scope.queuedTaskSummary[i]['priority_9_count']);
                $scope.queuedTaskSummary[i]['priority_10_count'] = parseInt($scope.queuedTaskSummary[i]['priority_10_count']);
            }

            if (!$scope.isTableInitialized) {
                initializeTable();
            }
            $scope.loadFailed = false;
            $rs.loadingInProgress = false;
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again.', 'error');
            $rs.loadingInProgress = false;
        });
    };

    var initializeTable = function() {
        $timeout(function() {
            var options = $.core.datatable.defaultOptions('queue');
            options.isIoTool = true;
            options.hasFixedHeader = false;
            options.dom = 'Rrplftp';
            options.order = [
                [0, 'asc']
            ];
            options.stateSave = false;
            $.core.datatable.build($('#queues-table'), options);
            $scope.table = $('#queues-table').DataTable();
        }, 0, false);
        $scope.isTableInitialized = true;
    };

    $scope.openTask = function(taskId) {
        $state.go('myTasksView', {
            taskId: taskId,
            fromPage: 'queueManager'
        });
    };

    $scope.openQueue = function(queueName) {
        $state.go('myQueues', {
            'filter': queueName
        });
    };

    $scope.sortTable = function(sortParam) {
        $scope.sortType = sortParam;
        $scope.sortReverse = !$scope.sortReverse;
    };

    var init = function() {
        $scope.loadFailed = true;
        ClusterService.initCluster($rs.userRole, 'multiSelectWithAllClusters');
        DateRangeService.init();
    };

    if ($rs.userRole && $rs.userRole.id) {
        init();
    } else {
        UserService.getCurrentUserRole().then(function() {
            $rs.userRole = UserService.userRole;
            init();
        }, function() {});
    }
}

AddAdminQueuesController.$inject = ['$scope', '$rootScope', '$stateParams', 'QueuesService', 'ClusterService', 'DateRangeService', 'UserService', '$state'];

function AddAdminQueuesController($scope, $rs, $stateParams, QueuesService, ClusterService, DateRangeService, UserService, $state) {
    $scope.queueObj = {};
    $scope.clusters = null;
    $scope.queueTypes = null;
    $scope.users = null;

    if ($stateParams.id) {
        $scope.isNew = false;
        $scope.queueText = "Edit Queue";
        $scope.btnText = "Update";
        $scope.queueObj.id = $stateParams.id;
    } else {
        $scope.isNew = true;
        $scope.btnText = "Save";
        $scope.queueText = "Add Queue"
        $scope.queueObj.enableBroadcastNotifications = true;
    };

    var clusterSelector = $rs.$on('ClusterChanged', function(event, args) {
        $scope.clusters = ClusterService.clusters;
        if (!$scope.isNew) {
            const queueAccess = 1;
            UserService.getUsersForQueue(
                $scope.queueObj.id, 
                [], // we will get users for queue and all clusters
                queueAccess,
            ).then(function(users) {
                $scope.users = users;
                $scope.queueObj.users = users.filter(user => user.round_robin == 1);
            }, function(error) {
                console.log("Error getting users for queue");
            });
        }
    });

    $scope.$on('$destroy', function() {
        clusterSelector();
    });

    $scope.getQueue = function(queueId) {
        QueuesService.getQueue(queueId).then(function(response) {
            $scope.formatObj(QueuesService.queue);
            $scope.clusters = ClusterService.clusters;
        }, function(response) {
            console.log("error");
        });
    };

    var getTypeId = function() {
        QueuesService.getQueueTypes().then(function(success) {
            $scope.queueTypes = QueuesService.queueTypes;
            if ($scope.queueTypes && $scope.queueTypes.length) {
                $scope.queueObj.typeId = $scope.queueTypes[0].id;
            }
        }, function(error) {
            console.log("error loading queue types")
        })
    };

    $scope.formatObj = function(queObj) {
        var keys = Object.keys(queObj);
        for (var i = 0, len = keys.length; i < len; i++) {
            switch (keys[i]) {
                case 'name':
                    $scope.queueObj.name = queObj[keys[i]];
                    break;
                case 'type_id':
                    $scope.queueObj.typeId = queObj[keys[i]];
                    break;
                case 'cluster_id':
                    $scope.queueObj.clusterId = queObj[keys[i]];
                    break;
                case 'reference_id':
                    $scope.queueObj.referenceId = queObj[keys[i]];
                    break;
                case 'description':
                    $scope.queueObj.description = queObj[keys[i]];
                    break;
                case 'round_robin':
                    $scope.queueObj.enableRoundRobin = queObj[keys[i]] == 1 ? true : false;
                    break;
                case 'enable_broadcast_notifications':
                    $scope.queueObj.enableBroadcastNotifications = queObj[keys[i]] == 1 ? true : false;
                    break;
            }
        }
    };

    $scope.saveQueue = function(queueForm) {
        if (queueForm.$valid) {
            if ($scope.isNew) {
                QueuesService.saveQueue($scope.queueObj).then(function(succsess) {
                    $scope.backToQueues();
                }, function(error) {
                    console.log("error");
                });
            } else {
                $scope.queueObj.userIds = $scope.queueObj.users?.map(user => user.id);
                $scope.queueObj.allUserIds = $scope.users?.map(user => user.id);
                QueuesService.updateQueue($scope.queueObj).then(function(succsess) {
                    $scope.backToQueues();
                }, function(error) {
                    console.log("error");
                });
            }
        }
    };

    $scope.backToQueues = function() {
        if ($stateParams && $stateParams.comeFrom == 'adminTask') {
            $state.go('addAdminTasks', {'taskInfo': $stateParams.taskInfo});
        } else {
            $state.go('adminQueues');
        }
    };

    var init = function() {
        getTypeId();
        ClusterService.initCluster($rs.userRole);
        DateRangeService.init();

        if ($stateParams.id) {
            $scope.getQueue($stateParams.id);
        } else {
            $scope.clusters = ClusterService.clusters;
        }
    };

    if ($rs.userRole && $rs.userRole.id) {
        init();
    } else {
        UserService.getCurrentUserRole().then(function() {
            $rs.userRole = UserService.userRole;
            init();
        }, function() {});
    }
}

AdminQueuesController.$inject = ['$scope', '$rootScope', 'QueuesService', 'UserService', 'ClusterService', 'DateRangeService', '$state', '$ioAlert', 'FormService'];

function AdminQueuesController($scope, $rs, QueuesService, UserService, ClusterService, DateRangeService, $state, $ioAlert, FormService) {
    $scope.queues = [];
    $scope.loadFail = false;
    $scope.active = 1;
    $scope.sortReverse = false;
    $scope.sortType = 'id';
    $scope.disableBtnAction = false;

    var clusterSelector = $rs.$on('ClusterChanged', function(event, args) {
        $scope.getQueues(ClusterService.clusterIds[0]);
    });

    $scope.$on('$destroy', function() {
        clusterSelector();
    });

    $scope.getQueues = function(clusterIds) {
        $rs.loadingInProgress = true;
        $rs.loadertitle = "Fetching Queues";
        QueuesService.getQueues(clusterIds, $scope.active).then(function(response) {
            $scope.queues = QueuesService.queues;
            for (var i = 0, len = $scope.queues.length; i < len; i++) {
                $scope.queues[i].id = parseInt($scope.queues[i].id);
            }
            $rs.loadingInProgress = false;
        }, function(response) {
            $rs.loadingInProgress = false;
        });
    };

    $scope.editQueue = function(queue) {
        if (queue) {
            $state.go('editAdminQueues', {
                id: queue.id
            });
        }
    };

    $scope.toggleQueues = function(active) {
        $scope.active = active;
        $scope.getQueues(ClusterService.clusterIds);
    };

    $scope.addQueue = function() {
        $state.go('addAdminQueues');
    };

    $scope.updateState = function(queueId) {
        var param = {
            "id": queueId
        };
        QueuesService.toggleState(param).then(function(data) {
            if (data) {
                $scope.getQueues(ClusterService.clusterIds[0]);
                $ioAlert.show('Deleted', 'Queue successfully deleted', 'success');
            }
        }, function(error) {
            console.log("error updating queues state");
        });
    };

    /*
    * Handle get instance lock configuration
    */
    var getInstanceLockConfig = function() {
        FormService.getInstanceLockConfig().then(function(data) {
            if(data.instanceLocked) {
                $scope.disableBtnAction = true;
            } else {
                $scope.disableBtnAction = false;
            }

        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }

    var init = function() {
        ClusterService.initCluster($rs.userRole);
        DateRangeService.init();
        getInstanceLockConfig();
        UserService.adjustStickyHeader();

    };
    UserService.adjustStickyHeaderWindowResize();

    if ($rs.userRole && $rs.userRole.id) {
        init();
    } else {
        UserService.getCurrentUserRole().then(function() {
            $rs.userRole = UserService.userRole;
            init();
        }, function() {});
    }
}